import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { DefaultLayout } from 'src/components/layout';
import ProtectedRouter from './protectedRouter';
import ScrollToTop from './scrollToTop';
import { GAPageView } from './reactGA';

const SignInViewRouter = React.lazy(() => import('src/views/signIn'));
const ResetPwEmailRouter = React.lazy(() => import('src/views/resetPw/email'));
const ResetPwPasswordRouter = React.lazy(() => import('src/views/resetPw/password'));
const MainRouter = React.lazy(() => import('src/views/main'));
const FeedRouter = React.lazy(() => import('src/views/feeds/router'));
const ProgramRouter = React.lazy(() => import('src/views/program/router'));
const ContractRouter = React.lazy(() => import('src/views/contract/router'));
const SignUpRouter = React.lazy(() => import('src/views/signUp/router'));
const ProfileRouter = React.lazy(() => import('src/views/profile/router'));
const MySettingeRouter = React.lazy(() => import('src/views/mySetting/router'));
const InvoiceRouter = React.lazy(() => import('src/views/invoice/router'));
const CommonPlusRouter = React.lazy(() => import('src/views/partnership/router'));
const NoticeRouter = React.lazy(() => import('src/views/notice/router'));
const SettingRouter = React.lazy(() => import('src/views/setting/router'));
const ScheduleRouter = React.lazy(() => import('src/views/schedule/router'));
const BannerRouter = React.lazy(() => import('src/views/banner/router'));
const PartnerRouter = React.lazy(() => import('src/views/partner/router'));
const Notificaion = React.lazy(() => import('src/views/notification/router'));
const TermsLibeto200830 = React.lazy(() => import('src/views/terms/termsLibeto200830'));
const TermsLibeto250109 = React.lazy(() => import('src/views/terms/termsLibeto250109'));
const Terms200830 = React.lazy(() => import('src/views/terms/terms200830'));
const Terms180410 = React.lazy(() => import('src/views/terms/terms180410'));
const Terms250106 = React.lazy(() => import('src/views/terms/terms250106'));
const PrivacyLibeto200806 = React.lazy(() => import('src/views/privacy/privacyLibeto200806'));
const PrivacyLibeto250109 = React.lazy(() => import('src/views/privacy/privacyLibeto250109'));
const Privacy180410 = React.lazy(() => import('src/views/privacy/privacy180410'));
const Privacy200806 = React.lazy(() => import('src/views/privacy/privacy200806'));
const Privacy250106 = React.lazy(() => import('src/views/privacy/privacy250106'));
const PrivacyRequired = React.lazy(() => import('src/views/privacyRequired'));
const PrivacySelect = React.lazy(() => import('src/views/privacySelect'));
const SgPrivacy200729 = React.lazy(() => import('src/views/privacy/SgPrivacy200729'));
const SgTerms200829 = React.lazy(() => import('src/views/terms/SgTerms200729'));
const SsoRouter = React.lazy(() => import('src/views/sso'));

const Router = () => {
  return (
    <BrowserRouter>
      <GAPageView />
      <ScrollToTop />
      <Switch>
        <DefaultLayout>
          <ProtectedRouter exact={true} path='/' component={MainRouter} />
          <Route path='/login' component={SignInViewRouter} />
          <Route path='/resetPw/email' component={ResetPwEmailRouter} />
          <Route path='/resetPw/password' component={ResetPwPasswordRouter} />
          <Route path='/Account' component={SignUpRouter} />
          <Route path='/terms/libeto2000830' component={TermsLibeto200830} />
	  <Route path='/terms/libeto250109' component={TermsLibeto250109} />	
          <Route path='/terms/2000830' component={Terms200830} />
          <Route path='/terms/180410' component={Terms180410} />
          <Route path='/terms/250106' component={Terms250106} />
          <Route path='/termsSg/200729' component={SgTerms200829} />
          <Route path='/privacy/libeto200806' component={PrivacyLibeto200806} />
	  <Route path='/privacy/libeto250109' component={PrivacyLibeto250109} />
          <Route path='/privacy/200806' component={Privacy200806} />
          <Route path='/privacy/180410' component={Privacy180410} />
          <Route path='/privacy/250106' component={Privacy250106} />
          <Route path='/privacySg/200729' component={SgPrivacy200729} />
          {/* privacyRequired와 privacySelect는 한국 회원가입시 보여주는 약관 */}
          <Route path='/privacyRequired' component={PrivacyRequired} />
          <Route path='/privacySelect' component={PrivacySelect} />
          <ProtectedRouter path='/feeds' component={FeedRouter} />
          <ProtectedRouter path='/program' component={ProgramRouter} />
          <ProtectedRouter path='/contract' component={ContractRouter} />
          <ProtectedRouter path='/mySetting' component={MySettingeRouter} />
          <ProtectedRouter path='/invoice' component={InvoiceRouter} />
          <ProtectedRouter path='/profile' component={ProfileRouter} />
          <ProtectedRouter path='/plus' component={CommonPlusRouter} />
          <ProtectedRouter path='/notice' component={NoticeRouter} />
          <ProtectedRouter path='/schedule' component={ScheduleRouter} />
          <ProtectedRouter path='/setting' component={SettingRouter} />
          <ProtectedRouter path='/banner' component={BannerRouter} />
          <ProtectedRouter path='/partner' component={PartnerRouter} />
          <ProtectedRouter path='/notification' component={Notificaion} />
          <ProtectedRouter path='/sso/login' component={SsoRouter} />
        </DefaultLayout>
      </Switch>
    </BrowserRouter>
  )
}

export default Router;



// WEBPACK FOOTER //
// ./src/modules/router.tsx